import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  Drawer,
  IconButton,
  Box,
  Button,
  Divider
} from '@mui/material';

import {
  Settings as SettingsIcon,
  ArrowLeft as ArrowLeftIcon
} from '@mui/icons-material';

import classes from './classes.module.scss';
import FilterOperatorToggle from './FilterOperatorToggle';

import {
  setFilterModelOperator
} from 'app/actions/filters';

import {
  OPERATOR_KEY,
  AND_OPERATOR
} from 'app/hooks/useFilter';

const FilterOptions = props => {
  const {
    resource,
    agGrid
  } = props;

  // get filterModel from redux when it updates
  const reduxParams = useSelector(state => state.params[resource]);
  const filterModel = reduxParams?.filter_model;
  const operatorFilter = filterModel && filterModel[OPERATOR_KEY];

  const operatorValue = (
    operatorFilter &&
    operatorFilter[0] &&
    operatorFilter[0].value
  ) || AND_OPERATOR;

  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);

  // setup filter model operator toggle
  const dispatch = useDispatch();
  const onChange = value => dispatch(setFilterModelOperator({
    resource,
    operator: value
  }));

  let headerHeight = agGrid.getHeaderHeight();
  if (headerHeight) {
    headerHeight = parseInt(headerHeight.match(/\d+/)[0]);
  }
  if (headerHeight) {
    headerHeight -= 1; // -1px for styling
    headerHeight += 'px';
  }

  const menuHeight = headerHeight || '129px';
  const menuWidth = '97px';

  return (
    <Box
      className="filter-options-toggle"
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 99,
        height: menuHeight,
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {agGrid.filtersActiveRef.current && !isOpen && (
        <IconButton
          onClick={toggleMenu}
          sx={{
            position: 'absolute',
            left: 0,
            top: '1.25rem',
            transform: 'translateY(-50%)',
          }}
        >
          <SettingsIcon />
        </IconButton>
      )}
      <Drawer
        variant="persistent"
        anchor="left"
        open={isOpen}
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: isOpen ? menuWidth : 0,
          height: menuHeight,
          backgroundColor: 'unset',
          padding: '0.5rem 0',
          transition: 'width 0.3s ease',
          '& .MuiDrawer-paper': {
            position: 'absolute',
            top: 0,
            left: 0,
            width: menuWidth,
            height: menuHeight,
	    backgroundColor: '#f8f8f8',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            padding: '0.5rem',
	    margin: '1px 0 0 1px'
          },
        }}
      >
        <p className={classes.filterOptionsHeader}>
          <SettingsIcon className={classes.filterOptionsHeaderIcon} />
          Filter Options
        </p>
        <Divider className={classes.divider} />
        <p className={classes.filterOptionHeader}>Columns Join Operator</p>
        <IconButton
          onClick={toggleMenu}
          sx={{
            position: 'absolute',
            right: 0,
            top: '50%',
            transform: 'translateY(-50%)',
          }}
        >
          <ArrowLeftIcon className={classes.closeMenuButton} />
        </IconButton>
        <FilterOperatorToggle
          defaultValue={operatorValue}
          onChange={onChange}
        />
      </Drawer>
    </Box>
  );
};

export default FilterOptions;
